<script setup lang="ts">
import $ from 'jquery';
import { onMounted } from 'vue';

import type { MenuPanel } from './globals';
import { __PRETTY_USER_NAME__ } from './globals';
import MenuSinglePanel from './menu-single-panel.vue';
import { useGlobalSeacrh } from './util';

const props = defineProps<{
    panel: MenuPanel;
    compact?: boolean;
}>();

const ROOT = __ROOT__;
const APP_VERSION_QS = __APP_VERSION_QS__;
const { haveFattapp2Layout } = useGlobalSeacrh();

onMounted(() => {
    if(props.compact) {
        $(`#${props.panel.id}`).removeClass('in');
    }
});
</script>

<template>
    <MenuSinglePanel :panel="props.panel" no-auto-toggle :sidenav="props.compact" :sidenav-title="__PRETTY_USER_NAME__">
        <template #anchor>
            <img
                class="utente-icon"
                :src="`${ROOT}images/icons/${haveFattapp2Layout ? 'accountInfo2' : 'accountInfo'}.png`"
                alt="Account info"
            >
            <span v-if="!props.compact">{{ __PRETTY_USER_NAME__ }}</span>
            <img :src="`${ROOT}images/icons/arrowDown.png?${APP_VERSION_QS}`" alt="">
        </template>
        <template #menu-after>
            <li>
                <a
                    id="menu-item-exit"
                    class="menu-item"
                    :href="`${ROOT}LogoutHandler.cmd2?redirectToAuthPage=true`"
                >
                    <img width="32" height="32" :src="`${ROOT}images/icons/exit.png?${APP_VERSION_QS}`">
                    Uscita
                </a>
            </li>
        </template>
    </MenuSinglePanel>
</template>
